import React from "react"
import classes from "./booking.module.css"
import { Link } from "gatsby"

const Booking = () => {
  return (
    <div className={classes.Booking}>
      <Link to="/book-online">Book online</Link>
    </div>
  )
}

export default Booking
